import { render, staticRenderFns } from "./com-package-order-list.vue?vue&type=template&id=4e7e2322&"
import script from "./com-package-order-list.vue?vue&type=script&lang=js&"
export * from "./com-package-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports